/**
 * reminder-linked-item-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ReminderLinkedItemRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_REMINDER_LINKED_ITEM;
	public static tag : MessageTag = MessageTag.REQ_REMINDER_LINKED_ITEM;

  constructor (
    public objectId : number,
    public reminderId : number
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/reminders/reminder-linked-item-request.ts